<template>
  <div class="d-flex w-100">
    <base-widget title="Contact History">
      <contacts
        :items="contacts.items"
        :count="contacts.count"
        @page-change="fetch"
        @events-clicked="showEventsDetail"
      />
    </base-widget>
    <base-modal
      v-if="outreachSelected"
      id="outreach_detail_modal"
      :key="outreachModal && outreachSelected ? outreachSelected.pk : 'none'"
      :show="outreachModal"
      :show-close-button="true"
      @closed="outreachModal = false; outreachSelected = null"
    >
      <div class="pl-5 pt-4">
        <base-heading class="py-3">
          {{ customer.first_name }} {{ customer.last_name }}
        </base-heading>
        <base-text>{{ outreachSelected.edit.subject | striphtml }}</base-text>
        <base-text
          size="xs"
          muted
        >
          Sent {{ outreachSelected.edit.sent_date | nicedate }}
        </base-text>
        <base-list
          v-slot:default="{ item, index }"
          class="my-4"
          :items="outreachEvents"
        >
          <div class="d-flex justify-content-start align-items-center">
            <base-text
              muted
              class="text-uppercase"
              size="xs"
            >
              {{ item.date | nicedate('xsmall') }}
            </base-text>
            <base-text
              light
              class="text-capitalize mx-2"
              size="sm"
            >
              {{ item.event }}
            </base-text>
            <a
              v-if="item.url"
              :href="item.url"
              class="mx-2"
            >
              <base-text size="sm">{{ item.url }}</base-text>
            </a>
          </div>
        </base-list>
      </div>
    </base-modal>
  </div>
</template>
<script>
export default {

  name: 'ClientContactHistory',
  props: {
    contacts: {
      type: Object,
      required: true,
    },
    outreachEvents: {
      type: Array,
      required: true,
    },
    customer: {
      required: true,
    },
  },
  data() {
    return {
      outreachModal: false,
      outreachSelected: null,
    };
  },
  methods: {
    fetch(paginationParams = { page_size: 6, page: 1 }) {
      if (!this.customer || !this.customer.pk) {
        return;
      }
      this.$store.dispatch('outreachs/fetchCustomerOutreachContact', {
        customer_id: this.customer.pk,
        ...paginationParams,
      });
    },
    showEventsDetail(outreach) {
      console.log('Outreach clicked: ', outreach.pk);
      this.outreachSelected = outreach;
      this.outreachModal = true;
      this.$store.dispatch('events/fetchFiltered', {
        outreach: outreach.pk,
        customer_id: this.customer.pk,
      });
    },
  },
};
</script>
<style lang="css" scoped>
</style>
